import React, { FC, useCallback } from 'react';
import { FormattedMessage } from 'react-intl';
import { Button } from '../../../../components/common';
import {
  ClickOrigin,
  useTrackLearnMoreClickAnalytics,
} from '../../../../utils/hooks/bi/useTrackLearnMoreClickAnalytics';
import { IOuter } from '../EmptyState.types';

export const GetAppButton: FC<IOuter> = () => {
  const { trackLearnMoreClick } = useTrackLearnMoreClickAnalytics();

  const handleClick = useCallback(() => {
    window.open('https://www.wix.com/wix-lp/wix-app');
    trackLearnMoreClick(ClickOrigin.WixApp);
  }, [trackLearnMoreClick]);

  return (
    <Button size="small" skin="standard" priority="secondary" onClick={handleClick} dataHook="open-wix-app-page-button">
      <FormattedMessage id="empty-state.mobile-folder.get-app" />
    </Button>
  );
};
